module.exports = __webpack_public_path__ + "static/media/lorry.f1423c7c.png";